import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdMarketplaceApiClient } from './api-client';
import { ProductAdRenderer } from './productAd';
import { TextAd, ProductAd } from '../types';
import { AdMarketplaceSlotDivNames } from '../ad-slots';
import { sendGa4Impression } from '../../send-ga4-impression';

export class AdMarketplaceLoader {
    private readonly apiClient: AdMarketplaceApiClient;
    // private config: AdMarketplaceConfig;
    private readonly config: any;

    constructor(config: any) {
        this.config = config;
        this.apiClient = new AdMarketplaceApiClient(config);
    }

    async loadAds(keyword: string, slot: string): Promise<void> {
        try {
            const response = await this.apiClient.getSuggestions(keyword);
            // console.log('response----===', response)
            const resList: Array<TextAd | ProductAd> = [];
            if (response.product_ads?.length) resList.push(...response.product_ads);
            if (response.text_ads?.length) resList.push(...response.text_ads);
            if (resList.length) {
                this.renderUnifiedAds(resList);
                sendGa4Impression({
                    adType: 'Admarketplace',
                    containerName: slot,
                    adsLoaded: true,
                    window,
                });
            } else {
                sendGa4Impression({
                    adType: 'Admarketplace',
                    containerName: slot,
                    adsLoaded: false,
                    window,
                });
                this.hideContainerIfEmpty(window, slot);
            }
        } catch (error) {
            sendGa4Impression({
                adType: 'Admarketplace',
                containerName: slot,
                adsLoaded: false,
                window,
            });
            this.hideContainerIfEmpty(window, slot);
            throw error;
        }
    }

    private renderUnifiedAds(ads: Array<TextAd | ProductAd>): void {
        const container = document.getElementById(AdMarketplaceSlotDivNames.productAdContainer);
        if (!container) return;
        container.innerHTML = '';
        ads.forEach((ad, index) => {
            const adElement = document.createElement('div');
            adElement.className = 'admarketplace-product-ad-wrapper';
            container.appendChild(adElement);
            const root = createRoot(adElement);
            root.render(
                <ProductAdRenderer
                    ad={ad}
                    slotNumber={index + 1}
                    // onAdClick={this.handleAdClick}
                    // onVisible={this.handleAdVisible}
                />
            );
        });
    }

    private readonly hideContainerIfEmpty = (window: Window, containerId: string) => {
        const el = window.document.getElementById(containerId);
        if (!el) {
            return;
        }
        el.style.display = 'none';
    };
}


